import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=6184ca12&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=6184ca12&prod&lang=scss&scoped=true"
import style1 from "./OrderHistory.vue?vue&type=style&index=1&id=6184ca12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6184ca12",
  null
  
)

export default component.exports